import { GoogleAdsSmall } from "@wix/wix-ui-icons-common";
import htmlDataDefaults from "./../ricos-schema/legacy/statics/html.defaults.json";
import { HTMLData_Source } from "./../ricos-schema/next-schema";
import { quickActionsModalSections, RicosPluginToolbarNames } from "./../ricos-types";
import {
  changeSelectionToEndOfTextBlock
} from "./../wix-rich-content-common";
import { DEFAULTS_CONFIG } from "./defaults";
import { getAddButtons } from "./getAddButtons";
import { getToolbarButtons } from "./getToolbarButtons";
import { htmlConverter } from "./html-converter";
import { tiptapExtensions } from "./tiptap/tiptap";
import { InsertModal } from "./toolbar/insert-modal/InsertModal";
import { SliderModal } from "./toolbar/SliderModal";
import { HTML_TYPE } from "./types";
const pluginHtml = (config) => {
  const pluginConfig = { ...DEFAULTS_CONFIG, ...config };
  return {
    config: pluginConfig,
    type: HTML_TYPE,
    pmMarkConverters: [],
    pmNodeConverters: [htmlConverter],
    tiptapExtensions,
    getAddButtons: (config2, services) => getAddButtons(config2, services),
    toolbar: {
      names: [RicosPluginToolbarNames.HTML],
      getButtons: (config2, services) => getToolbarButtons(config2, services)
    },
    getQuickActions: () => [
      {
        id: "adSense",
        title: "QuickActionsPlugin_ActionTitle_AdSense",
        icon: GoogleAdsSmall,
        section: quickActionsModalSections.Embed,
        tags: ["advertisement", "google ads", "google", "monetization", "ad widget", "banner ad"],
        command: ({ editorCommands, editor }) => {
          changeSelectionToEndOfTextBlock(editor);
          editorCommands.insertBlockWithBlankLines(HTML_TYPE, {
            ...htmlDataDefaults,
            source: HTMLData_Source.ADSENSE
          });
        }
      }
    ],
    __exports: {
      InsertModal,
      SliderModal
    }
  };
};
export {
  pluginHtml
};
//# sourceMappingURL=editor.js.map

import { injectCss } from "./viewer-styles-inject";
injectCss();
